<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md10 lg8 xl6 text-left>
        <v-layout pt-6 wrap justify-center>
          <v-flex xs6 lg6>
            <v-btn text block light class="text-capitalize" disabled>
              <span style="font-family:poppinssemibold;font-size:18px;color:#000">Log In / Sign In</span>
            </v-btn>
            <v-progress-linear value="100" color="#63028F"></v-progress-linear>
          </v-flex>
        </v-layout>
        <!-- <v-layout pt-6 wrap justify-center>
          <v-flex px-2 xs6 lg4>
            <v-btn outlined block light color="#f1f1f1">
              <span style="font-family:poppinssemibold;font-size:14px;color:#000">CUSTOMER</span>
            </v-btn>
          </v-flex>
          <v-flex px-2 xs6 lg4>
            <v-btn outlined block light color="#f1f1f1">
              <span style="font-family:poppinssemibold;font-size:14px;color:#000">SELLER</span>
            </v-btn>
          </v-flex>
        </v-layout>-->
        <v-layout pt-6 wrap justify-center>
          <v-flex px-2 xs12 text-center>
            <span style="font-family:poppinsmedium;font-size:25px;color:#000">Welcome back,</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex px-2 xs12 text-center>
            <span
              style="font-family:poppinslight;font-size:15px;color:#D4D3D3"
            >Enter your mobile number to continue.</span>
          </v-flex>
        </v-layout>
        <v-form @submit.prevent="validateInput">
          <v-layout pt-8 wrap>
            <v-flex xs12>
              <v-text-field
                ref="phone"
                color="#63028F"
                placeholder="Mobile number"
                outlined
                dense
                type="number"
                v-model="phone"
              >
                <template v-slot:prepend-inner>
                  <v-layout wrap justify-center>
                    <v-flex pt-1 xs18 class="align-self-center">
                      <span style="font-family:poppinsregular;font-size:14px;color:#000">+91</span>
                    </v-flex>
                    <v-flex pl-2 xs1>
                      <v-divider vertical></v-divider>
                    </v-flex>
                  </v-layout>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-end>
            <v-flex xs12 md4 pt-4 text-right>
              <v-btn
                block
                dark
                color="#63028F"
                depressed
                class="text-capitalize"
                @click="validateInput"
                :ripple="false"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["pageData"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      phone: null,
    };
  },
  beforeMount() {
    this.phone = this.pageData.phone;
  },
  methods: {
    validateInput() {
      if (!this.phone) {
        this.msg = "Please enter your number";
        this.showsnackbar = true;
        return;
      } else if (this.phone.length != 10) {
        this.msg = "Please enter valid number";
        this.showsnackbar = true;
      } else this.login();
    },
    login() {
      var userData = {};
      userData["phone"] = this.phone;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/getsms",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status && !response.data.isnew) {
            this.$emit("stepper", {
              phone: this.phone,
              response: response.data,
              winStep: 1,
            });
          } else if (response.data.isnew) {
            this.$emit("stepper", {
              phone: this.phone,
              response: response.data,
              winStep: 2,
            });
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #c8c8c8;
}
.separator::before {
  margin-right: 0.25em;
}
.separator::after {
  margin-left: 0.25em;
}
</style>